module.exports = __webpack_public_path__ + "static/Google-Home-ae62f24ab876734124fd78ee5271b93d.svg";